import { RootState } from 'store';

export const selectLoading = (state: RootState) => state.cognito.loading;
export const selectSuccess = (state: RootState) => state.cognito.success;
export const selectError = (state: RootState) => state.cognito.error;
export const selectCognitoUser = (state: RootState) => state.cognito.cognitoUser;
export const selectActiveGroupId = (state: RootState) => state.cognito.activeGroupId;
export const selectInProcess = (state: RootState) => state.cognito.inProcess;
